import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
  styled,
  Tab,
  Tabs,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SortIcon from "../../assets/icons/Sort.svg";
import SVG from "react-inlinesvg";
import { useLocation, useNavigate } from "react-router-dom";
import { links } from "../../constants/links";
import { useInfiniteQuery } from "react-query";
import { getAds } from "../../services/ads/ads.service";
import { Loading } from "../../components";
import { commonDateFormat } from "../../utils/date-format";
import moment from "moment";
import { ListStatus } from "../use-reward";
import { getValueByLanguage, isExpiredToday } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import { LIST_LANGUAGE_ENUM } from "../../constants";
import { LOCAL_STORAGE_KEY_CURRENT_LANGUAGE } from "../../constants";
import {
  ListRewardsWrapper,
  VoucherWrapper,
  ViewMoreBtn,
  ExpiredDate,
  ListWrapper
} from "../multi-coupons/MultiCoupons.styles";


const defaultCountry = process.env.REACT_APP_DEFAULT_COUNTRY;

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};


const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const sortFields = {
  EXPIRED_DATE: "expire_date",
  ACTION_AND_REWARD: "action_and_reward",
  REWARD_SUMMARY: "reward_summary"
};

const sortDirection = {
  ASC: "",
  DESC: "-"
};

const sortEarnList = [
  {
    label: "sortByDate",
    key: sortFields.EXPIRED_DATE
  },
  {
    label: "sortByAlphabet",
    key: sortFields.ACTION_AND_REWARD
  }
];

const sortUseList = [
  {
    label: "sortByDate",
    key: sortFields.EXPIRED_DATE
  },
  {
    label: "sortByAlphabet",
    key: sortFields.REWARD_SUMMARY
  }
];

const MAX_PER_PAGE = 10;
const TABS = {
  EARN: 0,
  USE: 1
};

const ListRewards = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { t } = useTranslation();
  const tab = TABS.USE;
  const [value, setValue] = useState(+tab);
  const [offsetUse, setOffsetUse] = useState(0);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [sortValue, setSortValue] = useState(sortFields.EXPIRED_DATE);
  const [direction, setDirection] = useState(sortDirection.DESC);
  const [sortUseValue, setSortUseValue] = useState(sortFields.EXPIRED_DATE);
  const [directionUse, setDirectionUse] = useState(sortDirection.DESC);
  const is_reload = searchParams.get("is_reload") ?? false;


  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const subcampaign_id = localStorage.getItem("subcampaign_id") || "";

  const {
    data: rawUseData,
    isLoading: isLoadingUse,
    fetchNextPage: fetchNextUsePage,
    isFetching: isFetchingUse
  } = useInfiniteQuery({
    queryKey: ["use", directionUse, sortUseValue],
    queryFn: ({ pageParam = 0 }) => {
      return getAds({
        type: "use",
        offset: pageParam,
        orderBy: directionUse + sortUseValue,
        defaultCountry: defaultCountry,
        language_code: localStorage.getItem(LOCAL_STORAGE_KEY_CURRENT_LANGUAGE) || LIST_LANGUAGE_ENUM.EN,
        subcampaign_id: subcampaign_id
      });
    },
    staleTime: Infinity,
  });

  useEffect(() => {
    if (is_reload) {
      window.location.replace(links.EARN_PAGE + "?tab=1");
    }
  }, [is_reload]);

  useEffect(() => {
    const newOffset = rawUseData && rawUseData?.pages ? (rawUseData?.pages.length - 1) * 10 : 0;
    setOffsetUse(newOffset);
  }, [rawUseData]);

  const navigate = useNavigate();

  const used = (data: any) => data?.status === ListStatus.COMPLETED;

  const handleUse = (item: any, used?: boolean) => {
    if (item.engage_session_id) {
      navigate(`${links.USE_REWARD_V2}/?engage-session=${item.engage_session_id}`, {
        state: { used: used, type: item.status, customer_subcampaign_id: item.customer_subcampaign_id, fromPath: "EARN_REWARD" }
      });
    } else {
      navigate(links.USE_REWARD.replace(":id", item.id), {
        state: { used: used, type: item.status, customer_subcampaign_id: item.customer_subcampaign_id, fromPath: "EARN_REWARD" }
      });
    }
  };

  const handleLoadMoreUse = async () => {
    await fetchNextUsePage({ pageParam: offsetUse + 10 });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeSort = (key: string) => {
    if (value === TABS.EARN) {
      if (key === sortValue) {
        if (direction === sortDirection.DESC) {
          setDirection(sortDirection.ASC);
        } else {
          setDirection(sortDirection.DESC);
        }
      } else {
        setSortValue(key);
        setDirection(sortDirection.ASC);
      }
    } else {
      if (key === sortUseValue) {
        if (directionUse === sortDirection.DESC) {
          setDirectionUse(sortDirection.ASC);
        } else {
          setDirectionUse(sortDirection.DESC);
        }
      } else {
        setSortUseValue(key);
        setDirectionUse(sortDirection.ASC);
      }
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const totalUseItems = rawUseData?.pages[0].total;
  const totalUsedItems = rawUseData?.pages[0].total_used_coupon;
  const totalExpiredItems = rawUseData?.pages[0].total_expired_coupon;
  const hasMoreUse = (
    rawUseData?.pages && rawUseData?.pages.length < Math.ceil((totalUseItems + totalUsedItems + totalExpiredItems) / MAX_PER_PAGE));
  const sortList = value === TABS.EARN ? sortEarnList : sortUseList;

  // components
  const viewMoreBtnWrapper = (
    <ViewMoreBtn
      onClick={handleLoadMoreUse}
      fullWidth
      variant="contained"
      disabled={isFetchingUse}
      style={{
        ...(
          process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__VIEW_MORE_ITEMS_BUTTON_BACKGROUND_COLOR
            ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__VIEW_MORE_ITEMS_BUTTON_BACKGROUND_COLOR }
            : {}
        ),
        ...(
          process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__VIEW_MORE_ITEMS_BUTTON_TEXT_COLOR
            ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__VIEW_MORE_ITEMS_BUTTON_TEXT_COLOR }
            : {}
        )
      }}
    >
      {t("viewMore")} - 10 {t("items")}
    </ViewMoreBtn>
  );

  const renderNowButton = (item: any) => {
    const isSingleExpired = !item?.is_multi_coupon && isExpiredToday(item.expired_at);
    const isAllMultiExpired = item?.is_multi_coupon && item?.is_all_coupon_expired;
    return (
      <Button
        sx={{ fontWeight: 400, fontSize: 12 }}
        variant="contained"
        onClick={() => handleUse(item)}
        disabled={isSingleExpired || isAllMultiExpired}
        style={{
          ...(
            process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__USE_NOW_BUTTON_BACKGROUND_COLOR
              ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__USE_NOW_BUTTON_BACKGROUND_COLOR }
              : {}
          ),
          ...(
            process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__USE_NOW_BUTTON_TEXT_COLOR
              ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__USE_NOW_BUTTON_TEXT_COLOR }
              : {}
          )
        }}
      >
        {t("useNow")}
      </Button>
    );
  };

  const showUsedErrorMessage = (item: any)=>{
    const isMulti = item.is_multi_coupon;
    if (isMulti) return (
      <ExpiredDate color="error">{t("used")}</ExpiredDate>
    );
    return (
      <ExpiredDate color="error">{`${t("used")}
      ${commonDateFormat(moment(item.used_at))}`}
      </ExpiredDate>
    );
  };

  const renderErrorOrUseButton = (item: any) => {
    const isCompleted = item.status === ListStatus.COMPLETED;
    const isMulti = item.is_multi_coupon;
    const activeCount = item.active_multi_coupons ?? 0;

    if (isCompleted) {
      if (isMulti && activeCount == 0) {
        return showUsedErrorMessage(item);
      }
      if (!isMulti) {
        return showUsedErrorMessage(item);
      }
    }
    return renderNowButton(item);
  };

  const RewardLogo = (item: any) => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className="ticket firstPart"
    >
      <img src={item.reward_logo_with_text} alt="rewards" />
    </Box>
  );

  const renderExpiredDate = (item: any) => {

    const showNormalExpiry = !used(item) && !(item?.is_multi_coupon);
    const showMultiCouponExpired = item?.is_multi_coupon && item?.active_multi_coupons > 0 && item?.is_all_coupon_expired;

    if (showNormalExpiry) {
      return (
        <>
          <Typography
            sx={{ fontSize: 12, fontWeight: 600, color: "#8D8D8D" }}
          >
            {t("expiredDate")}
          </Typography>
          <ExpiredDate
            color={isExpiredToday(item.expired_at) ? "error" : ""}
          >
            {commonDateFormat(moment(item.expired_at))}
          </ExpiredDate>
        </>
      );
    }

    if (showMultiCouponExpired) {
      return (
        <>
          <Typography
            sx={{ fontSize: 12, fontWeight: 600, color: "#8D8D8D" }}
          >
            {t("expired")}
          </Typography>
        </>
      );
    }

    return null;
  };

  const sortComponent = (
    <>
      <IconButton onClick={handleClick}><SVG src={SortIcon} /></IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <ListWrapper
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          aria-label="contacts"
        >
          {
            sortList.map((sort) => (
              <ListItem key={sort.key} disablePadding>
                <ListItemButton onClick={() => handleChangeSort(sort.key)}>
                  <ListItemText
                    className={(value === TABS.EARN ? sortValue : sortUseValue) === sort.key ? "active" : ""}
                    primary={t(sort.label)}
                  />
                  {(value === TABS.EARN ? sortValue : sortUseValue) === sort.key &&
                    <IconButton>
                      {
                        ((value === TABS.EARN ? direction : directionUse) === sortDirection.DESC) ?
                          <ArrowDownwardRoundedIcon color="error" /> :
                          <ArrowUpwardRoundedIcon color="success" />
                      }
                    </IconButton>
                  }
                </ListItemButton>
              </ListItem>
            ))
          }
        </ListWrapper>
      </Popover>
    </>
  );


  return (
    <ListRewardsWrapper>
      {(isLoadingUse) && <Loading />}
      <Box sx={{ width: "100%" }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" pr={2.5}>
          <Tabs
            value={0}
            // onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              icon={<span className="dot">{totalUseItems}</span>}
              label={t("use")}
              {...a11yProps(TABS.USE)}
              iconPosition="end"
            />
          </Tabs>
          <Box>
            {/* sort component to sort items */}
            {sortComponent}
          </Box>
        </Box>
        {/* <TabPanel value={value} index={0}>
        </TabPanel> */}
        <TabPanel value={value} index={1}>
          {
            rawUseData?.pages?.map((page, index) => (
              <React.Fragment key={"page_" + index}>
                {
                  page.data.map((item: any, i: number) => (
                    <VoucherWrapper
                      key={"use-item-" + i + "-" + item.id}
                      mb={2.5}
                      className=" testTicket"
                      onClick={
                        () => {
                          !item.is_3rdparty_coupon_use ?
                            (used(item) || isExpiredToday(item.expired_at)) ?
                              handleUse(item, true)
                              : handleUse(item)
                            : null;
                        }
                      }
                    >
                      {RewardLogo(item)}
                      <Box className="ticket-divider">
                        <div className="divider-border" />
                        <div className="notch"></div>
                        <div className="notch bottom"></div>
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                        className="ticket secondPart"
                      >
                        <Box>
                          <Typography
                            sx={{ fontSize: 12, fontWeight: 600 }}
                          >
                            {getValueByLanguage(item, "reward_summary")}
                          </Typography>
                          <Typography
                            sx={{ fontSize: 12 }}
                            className={"subCampaignTitle"}
                          >
                            {getValueByLanguage(item, "reward_use_criteria")}
                          </Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                          <Box>{
                            renderExpiredDate(item)
                          }
                          </Box>
                          {
                            renderErrorOrUseButton(item)
                          }
                        </Box>
                      </Box>
                    </VoucherWrapper>
                  ))
                }
              </React.Fragment>
            ))
          }
          {hasMoreUse && viewMoreBtnWrapper}
        </TabPanel>
      </Box>
    </ListRewardsWrapper>
  );
};

export default ListRewards;
